<div>
    <div class="aeg-flex-row-g2 flex-wrap">
        <div class="flex flex-col gap-2" style="flex: 1 0 auto">
            <div>
                <aeg-company-info :identifier="billingDetail.identifier" :name="billingDetail.companyName" />
            </div>
            <div>
                <address v-if="billingAddress" class="flex items-center gap-2">
                    <aeg-icon-location /><span>{{billingAddress}}</span>
                </address>
            </div>
            <div v-if="only1MailAddress" class="flex items-center gap-2">
                <aeg-icon-mail /><span>{{formatEmail(billingDetail.emails[0].email)}}</span>
            </div>
        </div>
        <div class="flex flex-col gap-2" v-if="!only1MailAddress" style="flex: 1 0 auto">
            <div v-for="email in billingDetail.emails" :key="email.service" class="flex items-center gap-2">
                <aeg-icon-mail /><span>{{email.service}}: {{formatEmail(email.email)}}</span>
            </div>
        </div>
    </div>
</div>
